var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTop2 = function SvgTop2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#top2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E7F1F4",
    d: "m18.917-.08 1.724 5.189 13.187 22.854 5.084-2.703L27.27 1.584 25-2.906 18.917-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B00",
    d: "m12.849-.552 5.153-2.74 15.172 28.535-5.153 2.74L12.849-.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D9E7EC",
    d: "m41.364-.625-5.083-2.703-15.098 28.394 5.084 2.703L39.093 5.594l2.271-6.219Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F00000",
    d: "m41.661-2.783 5.153 2.74L31.93 27.95l-5.153-2.74L41.661-2.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "m30.016 13.46-.836 15.337.836 15c8.367 0 15.171-6.805 15.171-15.172-.007-8.36-6.812-15.164-15.171-15.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M14.844 28.625c0 8.367 6.804 15.172 15.172 15.172V13.46c-8.368 0-15.172 6.805-15.172 15.164Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A7A7",
    d: "m30.016 15.805-.836 12.992.836 12.656c7.07 0 12.828-5.75 12.828-12.828-.008-7.07-5.758-12.82-12.828-12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8A7A7",
    d: "M17.187 28.625c0 7.07 5.75 12.828 12.829 12.828V15.805c-7.079 0-12.829 5.75-12.829 12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.297 34.18c3.937-3.532 6.273-6.258 6.273-8.492 0-1.47-.804-2.352-2.18-2.352-1.062 0-1.937.687-2.663 1.492l-1.57-1.57c1.335-1.414 2.624-2.195 4.609-2.195 2.742 0 4.57 1.765 4.57 4.468 0 2.625-2.18 5.453-4.82 8.04.726-.079 1.687-.157 2.351-.157h3.156v2.43h-9.726V34.18Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "top2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v44H0z"
  })))));
};
export default SvgTop2;